"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function value(value, defaultValue) {
    if (!value) {
        return defaultValue;
    }
    return value;
}
exports.value = value;
function values(value, defaultValue) {
    if (defaultValue === void 0) { defaultValue = []; }
    if (!value) {
        return defaultValue;
    }
    return value.filter(function (v) { return !!v; });
}
exports.values = values;
//# sourceMappingURL=maybe.js.map